import React from "react";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { match as Match } from "react-router-dom";
import ProductForm from "../form";
import { withTwoColLayout } from "../../../../utils";
import { EnumServiceType } from "../../../../lib/ground-aws-graphql-core/api/graphql/types";
import PageSubheader from "../../../../components/PageSubheader";

interface Props {
  serviceType: EnumServiceType;
  match: Match<{ cid: string; id: string; pid: string }>;
  intl: IntlShape;
  backURL: string;
}

const ProductUpdate = (props: Props) => {
  const { intl, serviceType, match, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: `page.product.${serviceType.toLowerCase()}.update.document.title`,
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId={`btn-back-product-${serviceType.toLowerCase()}-update`}
        goBackURL={backURL.replace(":id", match.params.id)}
      />

      <ProductForm {...props} edition />
    </>
  );
};

export default withTwoColLayout(injectIntl(ProductUpdate));
